export default {
  "Comércio": 1,
  "Serviço": 2,
  "Indústria": 3
};
